import {Simplex as BaseSimplex} from 'services/sports/default/simplex';
import Action from 'actions';
import ArrayHelper, {groupObjectsByProp} from 'helpers/array-helper';
import RuleBuilder from 'services/simplex/rule-builder';
import {getSimplexUnitName} from 'helpers/simplex-helper';
import Const from 'constants';

export default class SimplexClassic extends BaseSimplex {
    minTeams({incomingValues = {}}) {
        const state = Action.getState();
        const {sportConfig} = state;
        const {preparedPlayers} = state.playersData;
        const playersGrouped = preparedPlayers.groupedBy.allowedPositions();
        let teamRows = {},
            couples = {},
            maxPlayers = sportConfig.getConfigProp('offencePlayersInLineup') - 1,
            minTeams = Number(sportConfig.getConfigProp('minTeams'));

        const teams = groupObjectsByProp(
            playersGrouped.filter((player) => !player.isGoalie()),
            'team',
        );

        Object.keys(teams).map((teamName) => {
            let players = teams[teamName],
                addedPlayers = [];
            teamRows[teamName] = {};
            players.map((player) => {
                if (!inArray(player.playerId, addedPlayers)) {
                    teamRows[teamName][getSimplexUnitName(player.playerId)] = 1;
                    addedPlayers.push(player.playerId);
                }
            });
        });

        const rules = [];
        if (ArrayHelper.countItems(teams) > minTeams) {
            Object.keys(teamRows).map((tn1) => {
                Object.keys(teamRows).map((tn2) => {
                    if (tn1 !== tn2) {
                        let combi1 = tn1 + tn2,
                            combi2 = tn2 + tn1;
                        if (!couples.hasOwnProperty(combi1) && !couples.hasOwnProperty(combi2)) {
                            couples[combi1] = {...teamRows[tn1], ...teamRows[tn2]};
                        }
                    }
                });
            });
            Object.keys(couples).map((key) => {
                const ruleBuilder = RuleBuilder.fromAtMost(maxPlayers);
                ruleBuilder.addVars(couples[key]);
                rules.push(ruleBuilder.createRule());
            });
        } else {
            Object.keys(teamRows).map((key) => {
                const ruleBuilder = RuleBuilder.fromAtLeast(1);
                ruleBuilder.addVars(teamRows[key]);
                rules.push(ruleBuilder.createRule());
            });
        }
        // console.log("prepareSectionByMinTeams\n",result);
        return rules;
    }

    subjectToPermanent() {
        const constraints = {
            player: this.exec('player', {}, []),
            salary: this.exec('salary', {}, []),
            projectedOwnershipCap: this.exec('projectedOwnership', {}, []),
            teams: this.exec('team', {}, []),
            minTeams: this.exec('minTeams', {}, []),
            projectionBoostRule: this.exec('projectionBoostRule', {}, []),
            bound: this.exec('bound', {}, []),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            createdLineups: this.exec('createdLineups', {}, []),
            nhlTeamStacking: this.exec('nhlTeamStacking', {}, []),
            nhlLegacyTeamStacking: this.exec('nhlLegacyTeamStacking', {}, ''),
            nhlNameStacking: this.exec('nhlNameStacking', {}, []),
            nhlNonControlledStacking: this.exec('nhlNonControlledStacking', {}, []),
            exposureMax: this.exec('exposureMax', {}, []),
            exposureMin: this.exec('exposureMin', {}, []),
            flexExposureMax: this.exec('flexMaxExposure', {}, []),
            teamExposureMax: this.exec(
                'teamExposureMax',
                {
                    minPlayersQuantityToIdentifyUsedTeam: Const.NHL_MIN_PLAYERS_QUANTITY_TO_IDENTIFY_USED_TEAM,
                },
                [],
            ),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, []),
        };

        return {...constraints};
    }
}
